// theirs
import styled from 'styled-components'
// ours
import { TextOverImageProps } from '.'
import { breakpoints, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const textOverImageBaseClass = 'text-over-image'

export const StyledTextOverImage = styled.div<TextOverImageProps>`
    &.${textOverImageBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        background-image: url(${(props) =>
            appendLocationSingle(
                'images',
                props.content.contentBackgroundImageSource
            )});
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            text-align: center;
        }

        .content-inner {
            max-width: 550px;
            margin: 0 auto;
            display: grid;
            grid-gap: 1rem;
            grid-template-rows: 1fr 1fr;

            @media (min-width: ${breakpoints.lg}) {
                grid-gap: 0;
                max-width: 1000px;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: auto;
            }
        }

        .image-wrapper {
            align-self: center;

            ${(props) =>
                props.content.contentTextPosition === 'Left' &&
                `
                grid-column: 1;
                grid-row: 2;
            `}

            @media (min-width: ${breakpoints.lg}) {
                ${(props) =>
                    props.content.contentTextPosition === 'Left' &&
                    `
                grid-column: 2;
                grid-row: 1;
            `}
            }

            picture img {
                max-width: 300px;

                @media (min-width: ${breakpoints.lg}) {
                    max-width: 600px;
                }
            }
        }

        .text-wrapper {
            padding: 0;
            align-self: center;
            margin: 0 auto;
            max-width: 300px;

            ${(props) =>
                props.content.contentTextPosition === 'Left' &&
                `
                grid-column: 1;
                grid-row: 1;
            `}

            @media (min-width: ${breakpoints.lg}) {
                align-self: center;
                margin-right: -130px;
                max-width: 350px;

                ${(props) =>
                    props.content.contentTextPosition === 'Left' &&
                    `
                grid-column: 1;
                grid-row: 1;
            `}
            }

            p.text {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextColor};

                font-size: ${typography.size.s2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.s3};
                }

                @media (min-width: ${breakpoints.lg}) {
                    font-size: ${typography.size.m1};
                }
            }

            p.author {
                font-family: ${typography.type.secondary};
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: 1px;
                text-transform: uppercase;
                margin-top: 1rem;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextAuthorNameColor};
            }
        }
    }
`
